import _ from "@lodash";
import { AppBar, DialogActions, DialogContent, IconButton, InputAdornment, TextField, Toolbar, Typography } from "@material-ui/core";
import XAPPDialog from "app/Core/Components/Dialog/XAPPDialog";
import LookupApp_old from "app/Core/Components/Lookup_old/LookupApp_old";
import XAPPComponent from "app/Core/Components/XAPPComponent/XAPPComponent";
import * as Helpers from "app/Core/Helpers";
import * as AppActions from "app/store/actions";
import MobileDetect from "mobile-detect";
import React from "react";
import { MdClose } from "react-icons/md";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import XAPPButton from "../../Core/Components/Button/XAPPButton";
import EmpresaCategoriaApp from "../../ERP/EmpresaCategoria/EmpresaCategoriaApp";
import EmpresaProdutoApp from "../../ERP/EmpresaProduto/EmpresaProdutoApp";
import * as Actions from "./Store/Actions/TarefaApontamentoActions";
import EmpresaPessoaProdutoLookup from "app/ERP/EmpresaPessoaProduto/EmpresaPessoaProdutoLookup";
import EmpresaFormaPagamentoApp from "app/ERP/EmpresaFormaPagamento/EmpresaFormaPagamentoApp";

const md = new MobileDetect(window.navigator.userAgent);

const newTarefaApontamentoItemState = {
    idtemporario: new Date().getTime(),
    idtarefaprocessoapontamentoitem: null,
    idtarefaprocessoapontamento: null,
    idpessoaformulario: null,
    nome: null,
    valor: 0,
    valordescricao: "R$ 0,00",
    acrescimo: 0,
    desconto: 0,
    descontodescricao: "R$ 0,00",
    vencimento: null,
    quantidade: 1,
    idpessoaformulariocategoria: null,
    idpessoaformulariocategoriadescricao: null,
    idpessoaformularioformapagamento: null,
    idpessoaformularioformapagamentodescricao: null,
    observacao: null,
    baixa: null,
    validacao: null,
};

class TarefaApontamentoItemDialog extends XAPPComponent {

    state = { ...newTarefaApontamentoItemState };

    componentDidUpdate(prevProps, prevState) {
        const { Apontamento, open } = this.props;
        if (prevProps.open === null && open !== null) {
            var obj = Object.assign({}, newTarefaApontamentoItemState, open);
            obj.idtarefaprocessoapontamento = Apontamento.idtarefaprocessoapontamento;
            obj.natureza = Apontamento.natureza;
            obj.idtemporario = open.idtemporario ? open.idtemporario : new Date().getTime();
            this.setState(obj);
        }

        const form = this.state;
        if (!_.isEqual(prevState.desconto, form.desconto) || !_.isEqual(prevState.acrescimo, form.acrescimo) || !_.isEqual(prevState.valor, form.valor) || !_.isEqual(prevState.quantidade, form.quantidade)) {
            let AState = Object.assign({}, form);
            AState.valordescricao = "R$ " + (Number(form.valor) + Number(form.acrescimo)).toFixed(2);
            let AValorTotal = ((Number(form.valor) + Number(form.acrescimo)) - Number(form.desconto)) * Number(form.quantidade);
            AState.valortotaldescricao = "R$ " + AValorTotal.toFixed(2);

            if (!_.isEqual(prevState.desconto, form.desconto)) {
                AState.descontodescricao = "R$ " + Number(form.desconto).toFixed(2);
            }

            this.setState(AState);
        }

        if (!_.isNull(form.vencimento) && form.vencimento !== "" && !_.isEqual(form.vencimento, prevState.vencimento)) {
            this.setState(_.set({ ...this.state }, "vencimentodescricao", Helpers.StringDateUSToBR(form.vencimento)));
        }
    }

    handleChange = (event) => {
        this.setState(_.set({ ...this.state }, event.target.name, event.target.type === "checkbox" ? event.target.checked : event.target.value));
    };

    handleChangeFormaPagamento = (_AValue = null) => {
        var obj = Object.assign({}, this.state);
        if (!_.isNull(_AValue) && _AValue.length > 0) {
            obj["idpessoaformularioformapagamento"] = _AValue[0].idpessoaformulario;
            obj["idpessoaformularioformapagamentodescricao"] = _AValue[0].nome;
            this.setState(obj);
        }
        else {
            obj["idpessoaformularioformapagamento"] = null;
            obj["idpessoaformularioformapagamentodescricao"] = null;
            this.setState(obj);
        }
    };

    handleLookupEmpresaProduto = (_AValue = null) => {
        var obj = Object.assign({}, this.state);
        if (!_.isNull(_AValue) && _AValue.length > 0) {
            obj["idpessoaformulario"] = _AValue[0].idpessoaformulario;
            obj["nome"] = _AValue[0].nome;
            obj["valor"] = _AValue[0].valor;
            obj["descontomaximo"] = _AValue[0].formulario?.descontomaximo;
            obj["acrescimomaximo"] = _AValue[0].formulario?.acrescimomaximo;
            this.setState(obj);
        }
        else {
            obj["idpessoaformulario"] = null;
            obj["nome"] = null;
            obj["valor"] = null;
            obj["descontomaximo"] = null;
            obj["acrescimomaximo"] = null;
            this.setState(obj);
        }
    };

    handleLookupEmpresaInsumo = (_AValue = null) => {
        var obj = Object.assign({}, this.state);
        if (!_.isNull(_AValue) && _AValue.length > 0) {
            obj["idpessoaformulario"] = _AValue[0].idpessoaformulario;
            obj["nome"] = _AValue[0].nome;
            obj["valor"] = _AValue[0].valor;
            this.setState(obj);
        }
        else {
            obj["idpessoaformulario"] = null;
            obj["nome"] = null;
            obj["valor"] = null;
            this.setState(obj);
        }
    };

    canBeSubmitted() {
        const { idpessoaformulario, vencimento, quantidade, idpessoaformulariocategoria, idpessoaformularioformapagamento, valor } = this.state;
        const { Apontamento } = this.props;
        switch (Apontamento.natureza) {
            case 0:   // "Entrada de produto"
                return (
                    idpessoaformulario !== null && idpessoaformulario !== "" &&
                    valor !== null && valor !== "" &&
                    quantidade !== null && quantidade !== ""
                );
            case 1:  // "Contas a pagar"
                return (
                    vencimento !== null && vencimento !== "" &&
                    idpessoaformularioformapagamento !== null && idpessoaformularioformapagamento !== "" &&
                    idpessoaformulariocategoria !== null && idpessoaformulariocategoria !== ""
                );
            case 2:  // "Entrada de insumo"
                return (
                    idpessoaformulario !== null && idpessoaformulario !== "" &&
                    quantidade !== null && quantidade !== ""
                );
            case 3:  // "Saída de insumo"
                return (
                    idpessoaformulario !== null && idpessoaformulario !== "" &&
                    quantidade !== null && quantidade !== ""
                );
            case 4:   // "Saída de produto"
                return (
                    idpessoaformulario !== null && idpessoaformulario !== "" &&
                    quantidade !== null && quantidade !== ""
                );
            case 5:  // "Contas a receber"
                return (
                    vencimento !== null && vencimento !== "" &&
                    idpessoaformularioformapagamento !== null && idpessoaformularioformapagamento !== ""
                );
            case 6:  // "Apontamento de horas"
                return (
                    idpessoaformulario !== null && idpessoaformulario !== ""
                );
            case 7:   // "Orçamento"
                return (
                    idpessoaformulario !== null && idpessoaformulario !== "" &&
                    quantidade !== null && quantidade !== ""
                );
            case 15: // Suprimento de estoque
                return (
                    idpessoaformulario !== null && idpessoaformulario !== "" &&
                    quantidade !== null && quantidade !== ""
                );
            case 16: // Retirada de estoque
                return (
                    idpessoaformulario !== null && idpessoaformulario !== "" &&
                    quantidade !== null && quantidade !== ""
                );
            case 18:   // "Orçamento"
                return (
                    idpessoaformulario !== null && idpessoaformulario !== "" &&
                    quantidade !== null && quantidade !== ""
                );
            default:
                return false;
        }

    }

    getEmpresaCategoriaLookup = (_AChange) => {
        const { Apontamento } = this.props;
        var ATipo = Apontamento.natureza === 1 ? "1" : "2";
        return (
            <EmpresaCategoriaApp
                xappRouteParams={this.props.xappRouteParams}
                isLookup={true}
                multiSelect={false}
                onChange={_AChange}
                target="spvwempresacategoria"
                id="EmpresaFinanceiroEmpresaCategoria"
                filter={{
                    AND: [
                        { Campo: "pessoaformulario.formulario->>''natureza''", Operador: "=", Valor: "2" },
                        { Campo: "pessoaformulario.formulario->>''tipocategoria''", Operador: "=", Valor: ATipo }
                    ]
                }}
                onChangeLookup={this.onChangeLookup}
            />
        );
    };

    handleLookupEmpresaCategoria = (_AValue) => {
        var obj = Object.assign({}, this.state);
        if (_AValue) {
            obj["idpessoaformulariocategoria"] = _AValue["idpessoaformulario"];
            obj["idpessoaformulariocategoriadescricao"] = _AValue["nome"];
            this.setState(obj);
        }
        else {
            obj["idpessoaformulariocategoria"] = null;
            obj["idpessoaformulariocategoriadescricao"] = null;
            this.setState(obj);
        }
    };

    checkDescontoAcrescimo = _AValue => {
        let ADescontoMaximo = Number(_AValue.descontomaximo ?? 0);
        let AAcrescimoMaximo = Number(_AValue.acrescimomaximo ?? 0);
        if (ADescontoMaximo !== 0 && (Number(_AValue.desconto) > ADescontoMaximo)) {
            this.props.showMessage({
                message: `Valor de desconto não pode exceder R$ ${ADescontoMaximo.toFixed(2)}.`,
                variant: "error"
            });
            return false;
        }
        if (AAcrescimoMaximo !== 0 && (Number(_AValue.acrescimo) > AAcrescimoMaximo)) {
            this.props.showMessage({
                message: `Valor de acréscimo não pode exceder R$ ${AAcrescimoMaximo.toFixed(2)}.`,
                variant: "error"
            });
            return false;
        }
        return true;
    };

    render() {
        const { readOnly, open, openDialog, handleChangeItens, Apontamento, xappRouteParams, profissional = null } = this.props;
        const form = this.state;
        return (
            <React.Fragment>
                <XAPPDialog
                    id="TarefaApontamentoItem"
                    open={open !== null}
                    onClose={() => openDialog(null)}
                    fullWidth
                    fullScreen={md.mobile() !== null}
                    maxWidth={"md"}
                >
                    <AppBar position="static" elevation={1}>
                        <Toolbar className="flex w-full min-h-0">
                            <Typography variant="subtitle1 text-white">
                                {"Apontamento item"}
                            </Typography>
                            <div style={{ flex: 1 }} />
                            <IconButton
                                key="close"
                                aria-label="Close"
                                className="p-6"
                                onClick={() => openDialog(null)}
                            >
                                <MdClose className="text-20 text-white" />
                            </IconButton>
                        </Toolbar>
                    </AppBar>
                    <DialogContent classes={{ root: "p-20" }}>
                        <div className="flex w-full flex-wrap lg:flex-no-wrap">
                            {[0, 2, 3, 4, 7, 15, 16, 18].includes(Apontamento.natureza) &&
                                <TextField
                                    className="w-full lg:w-1/3 mt-8 mb-16 mx-4"
                                    label="Quantidade"
                                    id="quantidade"
                                    name="quantidade"
                                    variant="outlined"
                                    fullWidth
                                    value={form.quantidade}
                                    onChange={this.handleChange}
                                    disabled={readOnly}
                                    required
                                    type="Number"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />
                            }
                            {[0, 2, 3, 7, 15, 16].includes(Apontamento.natureza) &&
                                <EmpresaProdutoApp
                                    className="w-full flex flex-col mt-8 mb-16 mx-4"
                                    xappRouteParams={xappRouteParams}
                                    selected={!_.isNull(form.idpessoaformulario) ? [{ ...form, id: form.idpessoaformulario }] : []}
                                    label="Insumo"
                                    id="LookupTarefaProcessoApontamentoEmpresaProduto"
                                    campoid={"idpessoaformulario"}
                                    camponome={"nome"}
                                    onChange={this.handleLookupEmpresaInsumo}
                                    required={true}
                                    isLookup={true}
                                    multiSelect={false}
                                    readOnly={readOnly || form.idtarefaprocessoapontamentoitem !== null}
                                    filter={{ AND: [{ Campo: "(pessoaformulario.formulario->>''tipo'')::integer", Operador: "IN", Valor: "(1, 3)" }] }}
                                />
                            }
                            {[4, 18].includes(Apontamento.natureza) &&
                                <EmpresaPessoaProdutoLookup
                                    className="w-full flex flex-col mt-8 mb-16 mx-4"
                                    label="Produto / Serviço"
                                    xappRouteParams={xappRouteParams}
                                    selected={!_.isNull(form.idpessoaformulario) ? [{ ...form, id: form.idpessoaformulario }] : []}
                                    id="LookupTarefaProcessoApontamentoEmpresaProduto"
                                    campoid={"idpessoaformulario"}
                                    camponome={"nome"}
                                    onChange={this.handleLookupEmpresaProduto}
                                    required={true}
                                    isLookup={true}
                                    multiSelect={false}
                                    readOnly={readOnly}
                                    foreignKey={!_.isNull(profissional) ? profissional.idpessoaformulario : null}
                                />
                            }
                        </div>

                        <div className="flex w-full flex-wrap lg:flex-no-wrap">
                            {[0, 1, 2, 3, 4, 5, 6, 7, 18].includes(Apontamento.natureza) &&
                                <TextField
                                    className="mb-16 mx-4"
                                    label="Valor"
                                    id="valor"
                                    name="valor"
                                    required
                                    variant="outlined"
                                    fullWidth
                                    type="Number"
                                    disabled={readOnly}
                                    value={form.valor}
                                    onChange={this.handleChange}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    InputProps={{
                                        startAdornment: <InputAdornment position="start">R$</InputAdornment>
                                    }}
                                />
                            }
                            {[2, 3, 4, 6, 18].includes(Apontamento.natureza) &&
                                <TextField
                                    className="mb-16 mx-4"
                                    label="Desconto"
                                    id="desconto"
                                    name="desconto"
                                    variant="outlined"
                                    fullWidth
                                    type="Number"
                                    value={form.desconto}
                                    onChange={this.handleChange}
                                    disabled={readOnly}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    InputProps={{
                                        startAdornment: <InputAdornment position="start">R$</InputAdornment>
                                    }}
                                />
                            }
                            {[2, 3, 4, 6, 18].includes(Apontamento.natureza) &&
                                <TextField
                                    className="mb-16 mx-4"
                                    label="Acréscimo"
                                    id="acrescimo"
                                    name="acrescimo"
                                    variant="outlined"
                                    fullWidth
                                    type="Number"
                                    value={form.acrescimo}
                                    onChange={this.handleChange}
                                    disabled={readOnly}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    InputProps={{
                                        startAdornment: <InputAdornment position="start">R$</InputAdornment>
                                    }}
                                />
                            }
                        </div>
                        <div className="flex w-full flex-wrap lg:flex-no-wrap">
                            {[1, 5, 18].includes(Apontamento.natureza) &&
                                <TextField
                                    className="mb-16 mx-4"
                                    label="Vencimento"
                                    id="vencimento"
                                    name="vencimento"
                                    required
                                    variant="outlined"
                                    fullWidth
                                    value={form.vencimento}
                                    onChange={this.handleChange}
                                    disabled={readOnly}
                                    type="date"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />
                            }
                            {[1, 6].includes(Apontamento.natureza) &&
                                <LookupApp_old
                                    className="w-full flex mb-16 mx-4"
                                    instancia={this.getEmpresaCategoriaLookup}
                                    selected={this.state.idpessoaformulariocategoria !== null ? ([{ "id": this.state.idpessoaformulariocategoria, "label": this.state.idpessoaformulariocategoriadescricao }]) : ""}
                                    label="Categoria"
                                    id="LookupTarefaProcessoApontamentoEmpresaPessoa"
                                    campoid="idpessoaformulario"
                                    onChange={this.handleLookupEmpresaCategoria}
                                    required
                                    readOnly={readOnly}
                                />
                            }
                            {[1, 5].includes(Apontamento.natureza) &&
                                <EmpresaFormaPagamentoApp
                                    className="mb-16 mx-4"
                                    xappRouteParams={xappRouteParams}
                                    required={false}
                                    isLookup={true}
                                    multiSelect={false}
                                    onChange={this.handleChangeFormaPagamento}
                                    id="NovoFormaPagamento"
                                    key="NovoFormaPagamento"
                                    label="Forma de pagamento"
                                    selected={!_.isNull(form.idpessoaformularioformapagamento) ? [{ idpessoaformulario: form.idpessoaformularioformapagamento, nome: form.idpessoaformularioformapagamentodescricao }] : []}
                                    target="spvwempresaformapagamentolookup"
                                    autoSearch={true}
                                    selectFirstAuto={true}
                                />
                            }
                        </div>
                        <div className="flex w-full flex-wrap lg:flex-no-wrap">
                            <TextField
                                className="mb-16 mx-4"
                                label="Observações"
                                id="observacao"
                                name="observacao"
                                variant="outlined"
                                fullWidth
                                value={form.observacao}
                                onChange={this.handleChange}
                                disabled={readOnly}
                                multiline
                                rows={3}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                        </div>
                    </DialogContent>

                    <AppBar position="static" elevation={3} color="textSecondary">
                        <Toolbar className="flex w-full justify-end min-h-0">
                            {!readOnly &&
                                <DialogActions>
                                    <XAPPButton
                                        type="Button"
                                        className="bg-green hover:bg-green text-white"
                                        variant="contained"
                                        color="primary"
                                        disabled={!this.canBeSubmitted()}
                                        onClick={() => {
                                            if (this.checkDescontoAcrescimo(this.state)) {
                                                handleChangeItens(this.state);
                                                openDialog(null);
                                            }
                                        }}
                                        iconProps={md.mobile() === null && md.tablet() === null ? "mr-8" : "justify-center"}
                                        icon={"done"}
                                        label={md.mobile() === null && md.tablet() === null ? "OK" : ""}
                                    />
                                </DialogActions>
                            }
                        </Toolbar>
                    </AppBar>
                </XAPPDialog>
            </React.Fragment>
        );
    }
}


function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        save: Actions.save,
        remove: Actions.remove,
        showMessage: AppActions.showMessage,
    }, dispatch);
}

export default connect(null, mapDispatchToProps)(TarefaApontamentoItemDialog);
